import { useEffect, useRef } from 'react';
import { gsap } from '../../utils/gsap';

export function Loader({ onComplete }) {
  const ref = useRef(null);
  useEffect(() => {
    gsap.timeline({ onComplete: () => onComplete?.() })
      .to(ref.current, { opacity: 0, duration: 0.6, delay: 0.5, ease: 'power2.inOut' })
      .set(ref.current, { display: 'none' });
  }, []);
  return (
    <div ref={ref} style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 36, height: 36, border: '1.5px solid var(--color-border)', borderTop: '1.5px solid var(--color-accent)', borderRadius: '50%', animation: 'spin .8s linear infinite' }} />
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}
